import React from 'react'
import {ModalBase} from '../ModalBase'

const ModalNuevaPass = (props: any) => {
  return (
    <ModalBase Styles={{minWidth: '25%', maxWidth: '500px'}}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3
              className='card-title l'
              style={{color: '#13AD90', fontSize: '36px', width: '100%', textAlign: 'center'}}
            >
              Contraseña Actualizada
            </h3>
          </div>
          <div className='form-separator'></div>
          <p style={{textAlign: 'center'}}>Contraseña actualizada correctamente.</p>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.onClose}>
              Aceptar
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalNuevaPass
